<div class="flex-same-size">&nbsp;</div>
<div class="logo-wrapper">
  <img src="assets/imgs/uoa_logo.png" class="cursor-pointer" alt="The University of Auckland logo" />
</div>
<div class="flex-same-size">&nbsp;</div>
